import { Image, ListProductItem } from '@musinsa/mds';
import styled from 'styled-components';

import type { GiftProduct } from '@/shared/@types';
import type { FC } from 'react';

import { gtmGift } from '@/shared/log/ga4';

type ProductItemProps = {
  product: GiftProduct;
} & { idx: number };

export const ProductItem: FC<ProductItemProps> = ({ idx, product }) => {
  const {
    goodsNo,
    imageUrl,
    goodsName,
    brandName,
    couponSaleRate,
    saleRate,
    couponPrice,
    price,
    finalPrice,
    finalDiscount,
  } = product;
  const discountRate = finalDiscount ?? couponSaleRate ?? saleRate ?? 0;
  const goodsPrice = finalPrice ?? couponPrice ?? price ?? 0;
  const linkUrl = `${import.meta.env.VITE_APP_MUSINSA_URL}/products/${goodsNo}`;
  return (
    <S.Container href={linkUrl} {...gtmGift.GoodsItem(idx, product)}>
      <S.Image src={imageUrl} alt={goodsName} />
      <ListProductItem
        column={3}
        discount={discountRate}
        price={goodsPrice}
        slotProps={{
          brand: { children: brandName },
          title: {
            children: <span className="break-all whitespace-break-spaces">{goodsName}</span>,
          },
        }}
        type="info"
      />
    </S.Container>
  );
};

const S = {
  Container: styled.a`
    display: flex;
    flex-direction: column;
    text-decoration: none;
    color: inherit;
  `,
  Image: styled(Image)`
    width: 100%;
  `,
};
